"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColonialRepresentation = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Turmoil_1 = require("../../turmoil/Turmoil");
const Resources_1 = require("../../Resources");
class ColonialRepresentation extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.COLONIAL_REPRESENTATION,
            cost: 10,
            metadata: {
                cardNumber: 'P71',
                description: 'Gain 3 M€ per colony you have.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.effect('You have +1 influence.', (eb) => {
                        eb.startEffect.plus().influence(1);
                    });
                    b.br;
                    b.megacredits(3).slash().colonies(1);
                }),
            },
        });
    }
    play(player) {
        const turmoil = Turmoil_1.Turmoil.getTurmoil(player.game);
        turmoil.addInfluenceBonus(player);
        const coloniesCount = player.getColoniesCount();
        player.addResource(Resources_1.Resources.MEGACREDITS, coloniesCount * 3);
        return undefined;
    }
}
exports.ColonialRepresentation = ColonialRepresentation;
//# sourceMappingURL=ColonialRepresentation.js.map